import { useRef, useState } from "react";
import { createRunCompletion, type RunCompletionStatus } from "../exercises/run-completion";

export function useRunCompletion() {
  const [status, setStatus] = useState<RunCompletionStatus>({ phase: "idle", error: "" });
  const controller = useRef<ReturnType<typeof createRunCompletion> | null>(null);
  if (!controller.current) controller.current = createRunCompletion(setStatus);
  return { ...controller.current, status };
}

export function RunCompletion({ completion }: { completion: ReturnType<typeof useRunCompletion> }) {
  return <section className="panel" aria-busy={completion.status.phase === "saving"}>
    {completion.status.phase === "saving"
      ? <p role="status">Der Durchlauf wird gespeichert …</p>
      : <><p role="alert">{completion.status.error}</p><button className="primary" onClick={() => void completion.retry()}>Abschluss erneut speichern</button></>}
  </section>;
}
